import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import ForgotPassword from './ForgotPassword';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    error,
    message,
    resetLinkSent,
  } = state.auth;
  return {
    isLoading,
    data,
    error,
    message,
    resetLinkSent,
  };
}

const Styled = withStyles(styles)(ForgotPassword);

export default connect(
  mapStateToProps,
)(Styled);
